<header>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark mb-5">
        <div class="container-fluid">
        <a class="navbar-brand" routerLink="/">DemBeck Coding</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/billing-form">Generate Bill</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/pricing">Pricing</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/contact">Contact</a>
                </li>
                <li class="nav-item" *ngIf="user().id==0; else isConnected">
                    <a class="nav-link" routerLink="/login">Login</a>
                </li>
                <ng-template #isConnected>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ user().firstName }}</a>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li><a class="dropdown-item" (click)="openMeDialog()">My infos</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item" routerLink="/admin" *ngIf="user().role == 'ADMIN'">Admin panel</a></li>
                            <li><a class="dropdown-item" routerLink="/admin/users" *ngIf="user().role == 'ADMIN'">Users panel</a></li>
                            <li><a class="dropdown-item" routerLink="/admin/prices" *ngIf="user().role == 'ADMIN'">Prices panel</a></li>
                            <li><a class="dropdown-item" routerLink="/user" *ngIf="user().role == 'USER'">User panel</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item bg-danger text-light" routerLink="/logout">Logout</a></li>
                        </ul>
                    </li>
                </ng-template>
            </ul>
        </div>
        </div>
    </nav>
</header>
<body>
    <div class="loading-overlay" *ngIf="loading">
        <div class="d-flex flex-column justify-content-center align-items-center vh-100 text-light">
            <span class="loader-spinner"></span>
            <h1 class="text-light">Loading</h1>
            <span class="loader-dots"></span>
        </div>
    </div>
    <router-outlet *ngIf="!loading"></router-outlet>
</body>
<footer></footer>
  